export default __webpack_public_path__ + "static/news23-07e314302d8343ecddd8b44afbd27773.jpg";